import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  generateLyrics: function (data) {
    return axios.post(`${window.apiURL}api/ai/lyrics/create`, data)
  },
  saveLyric: function (data) {
    return axios.post(`${window.apiURL}api/ai/lyrics/save`, data)
  },
  getLyrics: function () {
    return axios.get(`${window.apiURL}api/ai/lyrics`)
  },
  removeLyric: function (id) {
    return axios.delete(`${window.apiURL}api/ai/lyrics/remove/${id}`)
  },
  getHistory: function () {
    return axios.get(`${window.apiURL}api/virtual-manager`)
  },
  askManager: function (content) {
    return axios.post(`${window.apiURL}api/virtual-manager`, { content })
  },
  getArtistInsights: function (artistId) {
    return axios.get(`${window.apiURL}api/ai/artist-insights/${artistId}`)
  },
  createCover: function (params) {
    return axios.get(`${window.apiURL}api/ai/cover-generator`, { params })
  },
  getAICovers: function (params) {
    return axios.get(`${window.apiURL}api/ai/covers`, { params })
  },
  createBeat: function (params) {
    return axios.post(`${window.apiURL}api/ai/beat-generator`, params)
  },
  getAIBeats: function (params) {
    return axios.get(`${window.apiURL}api/ai/beats`, { params })
  },
  getAIBeat: function (id) {
    return axios.get(`${window.apiURL}api/ai/beats/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/ai.js